export function getPagination(key) {
    const pagination = JSON.parse(localStorage.getItem('pagination')) || {};
    return pagination[key] || 50;  // Default value
}

export function setPagination(key, value) {
    const pagination = JSON.parse(localStorage.getItem('pagination')) || {};
    pagination[key] = value;
    localStorage.setItem('pagination', JSON.stringify(pagination));
}